import type { DtoOrderOrderTypeEnum } from '@repo/api-types/order-retrieval';
import type { AssetType } from '@repo/types/asset';
import { invariant } from '@repo/utils/type.utils';

import type { AssetActionsConfig } from '../status-header.config';

export const getComponentConfig = (
    config: AssetActionsConfig,
    assetType: AssetType,
    orderType?: DtoOrderOrderTypeEnum
) => {
    if (assetType !== 'order') {
        return config[assetType];
    }

    invariant(orderType !== undefined);
    return config[assetType]?.[orderType];
};
